import { GameAnalytic } from '@/_models/game/GameAnalytic';
import { sendGameAnalytics } from '@/components/util';
import { GameTimerType } from '@/_models/Game';
import { jsonSafeParse } from '@/utils/json';
import DeviceManager from '@/components/util/deviceManager';

type TimerOptions = {
  limit: number;
  type: GameTimerType;
};
export default class GameAnalyticService {
  analytic: GameAnalytic;

  private timerOptions: TimerOptions;

  constructor(gameId: number, slug: string, timerOptions: TimerOptions) {
    this.analytic = new GameAnalytic({
      gameId,
      country: '',
      startDateTime: new Date(), // user local time
      slug,
      time: timerOptions.type === GameTimerType.StopWatch ? 1 : 0,
      completed: false,
    });
    this.timerOptions = timerOptions;
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        const analyticUser = jsonSafeParse(window.localStorage.getItem('analyticUser'));
        if (!analyticUser) {
          return;
        }
        const fingerprint = window.localStorage.getItem('fingerprint');
        const documentLocation = document.location;
        const documentTitle = document.title;
        let device: string;
        if (DeviceManager.isMobile()) {
          device = 'mobile';
        } else {
          device = DeviceManager.isTablet() ? 'tablet' : 'desktop';
        }
        const headers = {
          type: 'application/json',
        };
        const data = {
          type: 'event',
          analyticUser,
          eventCategory: 'Game',
          eventAction: 'Game',
          device,
          gameAnalytic: this.analytic,
          fingerprint,
          documentLocation,
          documentTitle,
        };
        const blob = new Blob([JSON.stringify(data)], headers);
        navigator.sendBeacon(`${process.env.REACT_API_DOMAIN || 'http://localhost:5030'}/v1/public/analytic/event`, blob);
      }
    });
  }

  private formatTime(currentGameTime: number) {
    return this.timerOptions.type === GameTimerType.StopWatch ? currentGameTime : this.timerOptions.limit * 60 * 1000 - currentGameTime;
  }

  public getTime() {
    return this.analytic.time;
  }

  public setName(name: string) {
    this.analytic.name = name;
  }

  public setTime(time: number) {
    this.analytic.time = time;
  }

  public getPoint() {
    return this.analytic.point;
  }

  public setPoint(point: number) {
    this.analytic.point = point;
  }

  public async update(data: any = {}, dbUpdate = true) {
    const obj = { ...data };
    if (data.time !== undefined) {
      obj.time = this.formatTime(data.time);
    }
    if (obj.id) delete obj.id;
    const newAnalytic = new GameAnalytic({ ...this.analytic, ...obj });
    if (dbUpdate) {
      const res = await sendGameAnalytics('event',{
        eventCategory: 'Game',
        eventAction: 'Game',
        gameAnalytic: newAnalytic,
      });
      if (res) {
        this.analytic = new GameAnalytic(res.data.data);
      }
    }
  }
}
